export interface ILeaseCompanyOptionSource {
    id: number;
    name: string;
}

export interface ILeaseLesseeOption {
    value: string;
    label: string;
    companyId?: number;
    isClient?: boolean;
}

const normalizeName = (value?: string | null): string => (value || '').trim().replace(/\s+/g, ' ');

const getComparableName = (value: string): string => normalizeName(value).toLocaleUpperCase();

export const buildLeaseLesseeOptions = (companies: ILeaseCompanyOptionSource[], clientName?: string | null): ILeaseLesseeOption[] => {
    const optionsByName = new Map<string, ILeaseLesseeOption>();

    companies.forEach((company) => {
        const label = normalizeName(company.name);
        if (!label) {
            return;
        }

        optionsByName.set(getComparableName(label), {
            value: `company:${company.id}`,
            label,
            companyId: company.id,
        });
    });

    const normalizedClientName = normalizeName(clientName);
    if (normalizedClientName) {
        const comparableClientName = getComparableName(normalizedClientName);
        if (!optionsByName.has(comparableClientName)) {
            optionsByName.set(comparableClientName, {
                value: `client:${normalizedClientName}`,
                label: normalizedClientName,
                isClient: true,
            });
        }
    }

    return Array.from(optionsByName.values()).sort((a, b) => a.label.localeCompare(b.label));
};

export const getLeaseLesseeSelectValue = (companyId: number | undefined, name: string | undefined, options: ILeaseLesseeOption[]): string => {
    if (companyId) {
        return `company:${companyId}`;
    }

    const normalizedName = normalizeName(name);
    if (!normalizedName) {
        return '';
    }

    return options.find((option) => getComparableName(option.label) === getComparableName(normalizedName))?.value || '';
};



// WEBPACK FOOTER //
// ./src/components/leases/sections/leaseLesseeOptions.ts